function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "layer1",
  transform: "translate(-394.12 -495.96)"
}, React.createElement("path", {
  id: "outer-circle",
  fill: "#3c3f42",
  d: "M405.8 495.96c-6.41.01-11.662 5.145-11.68 11.557v32.547c.018 6.413 5.27 11.552 11.68 11.561h36.779c6.405-.009 11.658-5.147 11.676-11.561v-4.2c-2.06.885-3.745.984-6.113 1.06v3.14c-.004 2.94-2.49 5.44-5.56 5.447H405.8c-3.076-.008-5.557-2.506-5.566-5.447v-32.547c.009-2.938 2.49-5.44 5.566-5.443h36.78c3.07.004 5.557 2.505 5.562 5.443v2.354c2.75.07 3.912.166 6.113 1.063v-3.417c-.018-6.412-5.269-11.546-11.674-11.557z"
}), React.createElement("path", {
  id: "inner-circle",
  strokeLinejoin: "round",
  d: "M450.21 534.2c5.723-.39 10.438-6.088 9.794-11.776-.415-4.106-3.375-7.91-7.397-9.034-2.922-1.002-6.039-.5-9.063-.621H423.23c-3.902.055-7.64 2.288-9.469 5.758-2.301 3.612-1.691 8.623 1.175 11.75 2.31 2.774 6.047 4.132 9.608 3.893 8.556.006 17.112.044 25.667.03",
  stroke: "#3c3f42",
  strokeLinecap: "round",
  strokeWidth: 6.397,
  fill: "none"
}));

var SvgLogoAnim = function SvgLogoAnim(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "svg4174",
    height: 59.376,
    viewBox: "0 0 68.905 55.665",
    width: 73.5,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoAnim, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-anim.707b10f2.svg";
export { ForwardRef as ReactComponent };